import { render, staticRenderFns } from "./DualSwipeAlert.vue?vue&type=template&id=0b2658a6&scoped=true"
import script from "./DualSwipeAlert.vue?vue&type=script&lang=js"
export * from "./DualSwipeAlert.vue?vue&type=script&lang=js"
import style0 from "./DualSwipeAlert.vue?vue&type=style&index=0&id=0b2658a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2658a6",
  null
  
)

export default component.exports